/**
 * Meta Pixel — chargement conditionné au consentement cookies (Loi 25).
 * Le script n'est PAS dans index.html : il est injecté ici seulement
 * si l'utilisateur a accepté les cookies.
 */

export const META_PIXEL_ID = "1378353047055040";
export const CONSENT_KEY = "cookie-consent";
export const CONSENT_EVENT = "cookie-consent-changed";

declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void;
    _fbq?: unknown;
  }
}

let initialized = false;

export const hasCookieConsent = (): boolean => {
  if (typeof window === "undefined") return false;
  try {
    return localStorage.getItem(CONSENT_KEY) === "accepted";
  } catch {
    return false;
  }
};

/** Injecte fbevents.js + fbq('init') une seule fois. Retourne true si prêt. */
export const initMetaPixel = (): boolean => {
  if (typeof window === "undefined") return false;
  if (!hasCookieConsent()) return false;
  if (initialized && window.fbq) return true;

  /* eslint-disable @typescript-eslint/no-explicit-any */
  const f = window as any;
  const b = document;

  if (!f.fbq) {
    const n: any = (f.fbq = function (...args: unknown[]) {
      n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
    });
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = "2.0";
    n.queue = [];
    const t = b.createElement("script");
    t.async = true;
    t.src = "https://connect.facebook.net/en_US/fbevents.js";
    const s = b.getElementsByTagName("script")[0];
    s?.parentNode?.insertBefore(t, s);
  }
  /* eslint-enable @typescript-eslint/no-explicit-any */

  window.fbq?.("init", META_PIXEL_ID);
  initialized = true;
  return true;
};

/** Envoie un événement standard si le consentement est donné. */
export const trackPixelEvent = (
  event: string,
  params?: Record<string, unknown>,
): boolean => {
  if (!initMetaPixel()) return false;
  if (params) window.fbq?.("track", event, params);
  else window.fbq?.("track", event);
  return true;
};

export const trackPixelPageView = () => trackPixelEvent("PageView");

/** Notifie l'app d'un changement de consentement (accept/refus). */
export const notifyConsentChange = (value: "accepted" | "declined") => {
  window.dispatchEvent(new CustomEvent(CONSENT_EVENT, { detail: value }));
};

export const isPixelReady = () => initialized;
